var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMillustrationsSlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 40,
  fill: "none",
  viewBox: "0 0 56 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 23,
  x: 8.5,
  y: 8.5,
  fill: "#fff",
  stroke: "#CCCCD9",
  rx: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8A8A99",
  fillRule: "evenodd",
  d: "M24.52 21.584a1.26 1.26 0 1 1-1.26-1.261h1.26zm.636 0a1.26 1.26 0 0 1 2.521 0v3.156a1.26 1.26 0 1 1-2.521 0zm1.26-5.062a1.26 1.26 0 1 1 1.261-1.26v1.26zm0 .635a1.26 1.26 0 1 1 0 2.521H23.26a1.26 1.26 0 0 1 0-2.521zm5.063 1.26a1.26 1.26 0 1 1 1.26 1.261h-1.26zm-.636 0a1.26 1.26 0 1 1-2.521 0V15.26a1.26 1.26 0 0 1 2.521 0zm-1.26 5.063a1.26 1.26 0 1 1-1.261 1.26v-1.26zm0-.636a1.26 1.26 0 0 1 0-2.521h3.156a1.26 1.26 0 1 1 0 2.521z",
  clipRule: "evenodd"
})));
export default SvgMillustrationsSlack;